export default __webpack_public_path__ + "static/media/sambinotwitter.51fe24e5.jpg";